export const mapLayersDict: any = {
    "RoadWorkSegmentsPODD": {
        caption: "Проекты организации дорожного движения",
        mapLayer: "MARoadWorkSegmentSQL"
    },
    "RoadAccidents": {
        caption: "Дорожно-транспортные происшествия",
        mapLayer: "MARoadAccidentForFilters"
    },
    "RoadAccidentSegments": {
        caption: "Участки концентрации ДТП",
        mapLayer: "MARoadAccidentSegment"
    },
    "RoadDiagnosticsSegments": {
        caption: "Участки диагностики",
        mapLayer: "MARoadDiagnosticsSegment"
    },
    "PathNormativitiesMeasureType": {
        caption: "Нормативные участки",
        mapLayer: "MADiagSegmentNormativity",
        styles: [
            {
                name: "Продольная ровность покрытия",
                style: "MADiagSegmentNormativityForYearRoughness",
                type: "Roughness"
            },
            {
                name: "Наличие дефектов",
                style: "MADiagSegmentNormativityForYearDefects",
                type: "Defects"
            },
            {
                name: "Поперечная ровность (колейность)",
                style: "MADiagSegmentNormativityForYearGaugeDepth",
                type: "GaugeDepth"
            },
            {
                name: "Прочность дорожно одежды",
                style: "MADiagSegmentNormativityForYearStrength",
                type: "Strength"
            },
            {
                name: "Коэффициент сцепления",
                style: "MADiagSegmentNormativityForYearCohesion",
                type: "Cohesion"
            },
            {
                name: "По всем показателям",
                style: "MADiagSegmentNormativityForYearTotal",
                type: "Total"
            }
        ]
    },
    "PathNormativitiesMeasureTypesGroup": {
        caption: "Нормативные участки",
        mapLayer: "MADiagSegmentNormativity"
    },
    "HighwayNetworkSegments": {
        caption: "Участки опорной сети",
        mapLayer: "MCHighwayNetworkSegment"
    },
    "RoadBedLayerSegments": {
        caption: "Типы дорожной одежды",
        mapLayer: "MARoadBedLayerSegment"
    },
    "RoadCategorySegments": {
        caption: "Категорийный участок дороги",
        mapLayer: "MARoadCategorySegmentTest"
    },
    "GeoMarkers": {
        caption: "Геомаркеры",
        mapLayer: "MAGeoMarker"
    },
    "Weather": {
        caption: "Метеостанции",
        mapLayer: "MCRoadWeatherStations"
    },
    "Cameras": {
        caption: "Дорожные камеры",
        mapLayer: "MCSurfaceLayer,RussianHighwaysCustom:RoadWebCameras"
    }
}